// extracted by mini-css-extract-plugin
module.exports = {"Root":"Button_Root__1sNY-","Inline":"Button_Inline__3Smq3","Default":"Button_Default__3yH_r","Confirm":"Button_Confirm__2dPmW","Cancel":"Button_Cancel__3Pgbn"};